<template>
  <div class="passport-application-list">
    <div
      v-for="(application, applicationKey) in applications"
      :key="applicationKey"
      :class="applicationCSSClass(application)"
      class="application-list"
      @dblclick="openApplication(applicationKey)"
    >
      <visitor-application-item
        :visitor-key="visitorKey"
        :application=application
        :application-key="applicationKey"
        :pagination="pagination"
        :user="user"
        :statuses="statuses"
        @update-statuses="updateStatuses"
        @splice-application="spliceApplication"
      />
    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteLoadApplications">
      <div slot="no-more">Показаны все записи</div>
      <div slot="no-results">Нет записей</div>
    </infinite-loading>
  </div>
</template>

<script>

import VisitorApplicationItem from './VisitorApplicationItem.vue'
import VisitorClient from '../../helpers/api-client/Visitor'
import ApplicationLogListDto from '../../classes/dto/ApplicationLogListDto'

export default {
  name: 'PassportApplicationList',

  components: {
    VisitorApplicationItem
  },

  props: {
    visitorKey: Number,
    passportId: Number,
    requiredArchived: Boolean,
    statuses: { type: Object }
  },

  data() {
    return {
      applications: [],
      infiniteId: 0,
      pagination: {
        active: 1,
        per: 5
      }
    }
  },

  methods: {
    applicationCSSClass(application) {
      return 'profile-application-color-' + application.status
    },

    openApplication(applicationKey) {
      this.$emit('open-application', applicationKey)
    },

    spliceApplication(deleteFrom, blockId, applicationId, index) {
      this.$emit('splice-application', deleteFrom, blockId, applicationId, index)
    },

    updateStatuses(status) {
      this.$emit('update-statuses', status)
    },

    async infiniteLoadApplications($state) {
      if (!this.applications.length) {
        this.pagination.active = 1
      }

      const applications = await this.getApplications()

      if (applications?.length) {
        this.pagination.active++
        this.applications.push(...applications)
        $state.loaded()
      } else if (applications?.length === 0) {
        $state.complete()
      } else {
        $state.error()
      }
    },

    async getApplications() {
      let results = []

      await VisitorClient.getApplications({
        page: this.pagination.active,
        perPage: this.pagination.per,
        visitorId: this.passportId,
        searchByPassport: true,
        archived: this.requiredArchived ? 1 : 0
      }).then((response) => {
        if (response?.data?.data?.length > 0) {
          results = response?.data?.data?.map(
            model => Object.assign(model, {
              logs: new ApplicationLogListDto(model.logs)
            })
          )
        }
      })

      return results
    }
  },

  watch: {
    requiredArchived() {
      this.pagination.active = 1
      this.applications = []
      this.infiniteId += 1
    }
  }
}
</script>
